import {
  createCustomerGroupError,
} from '../../../models/CustomerGroupModel';


function firstStepValidate({ getValues, setError }) {
  const nameField = `name`;
  const [
    name,
  ] = getValues([
    nameField,
  ]);
  const errorList = [];
  if (!name || name === '') {
    errorList.push({
      name: nameField,
      message: createCustomerGroupError.generalName.message,
    });
  }
  errorList.forEach((error) => {
    setError(
      error.name,
      {
        type: 'require',
        message: error.message,
      }
    );
  });
  return !errorList.length;
}

export function validate({ getValues, setError, clearErrors, step }) {
  console.log('@71 createCustomerGroupValidate:', getValues());
  clearErrors();
  switch (step) {
    default:
    case 0:
      const validStepOne = firstStepValidate({ getValues, setError });
      return validStepOne;
  }
}
